import { Form } from "react-bootstrap";
import AllTextState from "../../../state/AllTextState";

interface IProps {
  title: string;
  required?: boolean;
  children?: any;
  nativeTitle?: boolean;
  isSport?: boolean;
  labelColor?: string;
  fontWeight?: string;
}

const Label = (props: IProps): JSX.Element => {
  const required = props.required ? (
    <span className="text-color-light-red"> *</span>
  ) : null;
  return (
    <Form.Label style={props.labelColor ? { color: props.labelColor, fontWeight: props.fontWeight } : {}}>
      {props.nativeTitle
        ? !props.isSport
          ? props.title.replace("sports", "work")
          : props.title
        : AllTextState[props.title]}
      {required}
      {props?.children}
    </Form.Label>
  );
};

export default Label;
